import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { lazy, Suspense } from 'react';
import Providers from '../../Providers';
import { parseDomain } from '../../utils/handleDomain';
import { theme } from './SettingsTheme';
var Shops = lazy(function () { return import('../../modules/Shops'); });
var Support = lazy(function () { return import('../common/Support'); });
var OurApps = lazy(function () { return import('../common/OurApps'); });
var Subscription = lazy(function () { return import('../common/Subscription'); });
var Settings = function () {
    var publicSuffix = parseDomain(window.location.host).publicSuffix;
    var isUaDomain = publicSuffix === 'ua';
    return (_jsx(Suspense, { fallback: "Application is loading ...", children: _jsxs(Box, { sx: theme.container, children: [_jsx(Support, {}), _jsx(Subscription, {}), _jsx(Shops, {}), isUaDomain && _jsx(OurApps, {})] }) }));
};
var SettingsWrap = function (_a) {
    var userSettings = _a.userSettings;
    return (_jsx(Providers, { userSettings: userSettings, children: _jsx(Settings, {}) }));
};
export default SettingsWrap;
